import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../../Input";
import { Button } from "../../Button";
import language from "../../../language";
import axios from "axios";
import toastMessage from "../../../utils/toastMessage";
import { getStorage } from "../../../utils/storage";
import api from "../../../utils/api";
import { Modal } from "../../Modal";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;
class NewTransfer extends React.Component {
  state = {
    error: {},
    isSubmitting: false,
    user: {},
    packages: [],
    driverContact: "",
  
    coolerbox: null,
    driver: "",
    plateNumber: "",
    transportationTemperature: null,
};

  componentDidMount = async () => {
    const user = await getStorage();

    console.log(this.props.packages);

    if (this.props.packages?.length > 0) {
      console.log("I am here 13", this.props.packages);
      this.setState({
        driver: this.props.packages?.[0]?.driver,
        driverContact: this.props.packages?.[0]?.driverContact,
      });
    }
    this.setState({ user });
  };

  onChangeText = async (field, e) => {
    let { error } = this.state;
    let inputValue = e && e?.target ? e?.target?.value : e;
    delete error[field];

    await this.setState({
      [field]: inputValue,
      error,
    });
  };

  handleCheck(type, value) {
    this.setState({ [type]: value });
  }

  validateForm = async () => {
    let { error, driver, plateNumber, driverContact } = this.state;

    if (this.props.status === "pending") {
      if (!plateNumber || plateNumber === "") {
        error.plateNumber =
          language[this.props.defaultLanguage].plate_number_required;
      }
      if (!driver || driver === "") {
        error.driver = language[this.props.defaultLanguage].driver_required;
      }

      if (!driverContact || driverContact === "") {
        error.driverContact =
          language[this.props.defaultLanguage].driver_contact_required;
      }

      if (
        driverContact &&
        (driverContact.length < 10 || driverContact.length > 13)
      ) {
        error.driverContact =
          language[this.props.defaultLanguage].driver_contact_invalid;
      }

      if (!plateNumber || plateNumber === "") {
        error.plateNumber =
          language[this.props.defaultLanguage].plate_number_required;
      }
    }

    if (this.props.status === "received") {
      if (
        !this.state.transportationTemperature ||
        this.state.transportationTemperature === ""
      ) {
        error.transportationTemperature =
          language[
            this.props.defaultLanguage
          ].transportation_temperature_required;
      }
      if (Number(this.state.transportationTemperature) < 1) {
        error.transportationTemperature =
          language[
            this.props.defaultLanguage
          ].transportation_temperature_min_required;
      } else if (
        Number(this.state.transportationTemperature) > 10 &&
        Number(this.state.transportationTemperature) < 20
      ) {
        // This handles the invalid range 11-19
        error.transportationTemperature =
          language[
            this.props.defaultLanguage
          ].transportation_temperature_invalid_range;
      } else if (Number(this.state.transportationTemperature) > 24) {
        error.transportationTemperature =
          language[
            this.props.defaultLanguage
          ].transportation_temperature_max_required;
      }
    }

    this.setState({ error });
  };

  getPackage = async () => {
    try {
      let { coolerbox, error } = this.state;

      if (!coolerbox || coolerbox === "") {
        error.coolerbox =
          language[this.props.defaultLanguage].cooler_box_required;

        this.setState({ error });

        return;
      }
      this.setState({
        isSearching: true,
      });
      const options = {
        method: "GET",
        url: `${API_URL}/packaging`,
        params: {
          code: this.state.coolerbox?.toUpperCase()?.trim(),
          status: this.props.status === "received" ? "transferred" : "pending",
        },
      };
      const { data } = await api(options);

      if (data.length === 0) {
        toastMessage("error", language[this.props.defaultLanguage].not_found);
        this.setState({
          isSearching: false,
        });
        return null;
      }

      this.setState({
        packages: data,
        isSearching: false,
        openSubmit: true,
      });
    } catch (error) {
      toastMessage("error", error);
      this.setState({
        isSearching: false,
        openSubmit: false,
      });
      return null;
    }
  };

  onSubmit = async () => {
    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      let { user, transportationTemperature, packages } = this.state,
        url = `${API_URL}/packaging`,
        method = "PUT";

      let requestedBody = {
        driver: this.state.driver,
        driverContact: this.state.driverContact,
        plateNumber: this.state.plateNumber?.value,
        coolerBox: packages?.[0]?.coolerBox?._id,
        status: this.props.status || "transferred",
      };

      if (this.props.status === "received") {
        requestedBody.transportationTemperature = transportationTemperature;
      }

      const options = {
        method,
        url,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
        data: requestedBody,
      };
      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            `Donation has been ${this.props.status} successfully`
          );

          this.onReset();
        })
        .catch((error) => {
          this.setState({ isSubmitting: false });
          toastMessage("error", error);
        });
    }
  };

  onReset() {
    this.setState({
      coolerbox: "",
      error: {},
      // transportationTemperature: "",
      // plateNumber: "",
      // driver: "",
      // driverContact: "",
      isSearching: false,
      packages: [],
    });

    this.handleCloseModal("openSubmit", false);
  }

  handleOpenModal(modal) {
    this.setState({
      [modal]: true,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  getVehicles = async (search = {}) => {
    try {
      this.setState({
        isSearchingVehicle: true,
      });
      const options = {
        method: "GET",
        url: `${API_URL}/equipment`,
        params: {
          department: "transport",
          ...search,
        },
      };
      const { data } = await api(options);

      this.setState({
        isSearchingVehicle: false,
      });

      return data.map((el) => {
        return {
          ...el,
          label: `${el.name}(${el.code})`,
          value: el._id,
        };
      });
    } catch (error) {
      toastMessage("error", error);
      this.setState({
        isSearchingVehicle: false,
      });
      return null;
    }
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <Input
            placeholder={language[this.props.defaultLanguage].enter_number}
            label={language[this.props.defaultLanguage].cooler_box_number}
            required
            value={this.state.coolerbox}
            onChange={(e) => this.onChangeText("coolerbox", e)}
            error={this.state.error.coolerbox}
          />
        </div>

        <div className="d-flex gap-3">
          <>
            <Button
              text={language[this.props.defaultLanguage].reset}
              onPress={this.onReset.bind(this)}
              className="btn-default"
            />
            <Button
              text={language[this.props.defaultLanguage].search}
              onPress={this.getPackage.bind(this)}
              isSubmitting={this.state.isSearching}
              type="submit"
            />
          </>
        </div>

        <Modal
          handleClose={() => this.handleCloseModal("openSubmit", false)}
          show={this.state.openSubmit}
          title={language[this.props.defaultLanguage].transfer_package}
        >
          <div className="card-body">
            {this.props.status === "received" ? (
              <div className="col-md-12">
                <Input
                  placeholder={
                    language[this.props.defaultLanguage].enter_number
                  }
                  label={
                    language[this.props.defaultLanguage]
                      .transportation_temperature
                  }
                  required
                  value={this.state.transportationTemperature}
                  onChange={(e) =>
                    this.onChangeText("transportationTemperature", e)
                  }
                  error={this.state.error.transportationTemperature}
                  type="number"
                  max={30}
                />
              </div>
            ) : (
              <>
                <div className="col-md-12">
                  <Select
                    loadOptions={(e) =>
                      this.getVehicles({ code: e !== "" ? e : undefined })
                    }
                    placeholder={
                      language[this.props.defaultLanguage].enter_number
                    }
                    label={language[this.props.defaultLanguage].plate_number}
                    required
                    value={this.state.plateNumber}
                    onChange={(e) => this.onChangeText("plateNumber", e)}
                    error={this.state.error.plateNumber}
                  />
                </div>

                <div className="col-md-12">
                  <Input
                    placeholder={
                      language[this.props.defaultLanguage].driver_placeholder
                    }
                    label={language[this.props.defaultLanguage].driver}
                    required
                    value={this.state.driver}
                    onChange={(e) => this.onChangeText("driver", e)}
                    error={this.state.error.driver}
                  />
                </div>
                <div className="col-md-12">
                  <Input
                    placeholder={
                      language[this.props.defaultLanguage]
                        .phone_number_placeholder
                    }
                    label={
                      language[this.props.defaultLanguage].driver_phone_number
                    }
                    required
                    value={this.state.driverContact}
                    onChange={(e) => this.onChangeText("driverContact", e)}
                    error={this.state.error.driverContact}
                    type="number"
                    maxLength={10}
                  />
                </div>
              </>
            )}
          </div>
          <div className="modal-footer">
            <Button
              text={language[this.props.defaultLanguage].reset}
              onPress={this.onReset.bind(this)}
              className="btn-default"
            />
            <Button
              text={language[this.props.defaultLanguage].submit}
              onPress={this.onSubmit.bind(this)}
              isSubmitting={this.state.isSubmitting}
              type="submit"
            />
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewTransfer);
